import { colord, extend } from 'colord';
import lchPlugin from 'colord/plugins/lch';
import tinycolor from 'tinycolor2';
extend([lchPlugin]);
export function darkenColor(baseColor, { contrast = 4.5, minimumLightnessDistance = 0, } = {}) {
    const colorToTransform = baseColor.startsWith('#')
        ? baseColor
        : `#${baseColor}`;
    const color = colord(colorToTransform).toLch();
    const l = color.l;
    if (Number.isNaN(l)) {
        throw new Error(`couldn't parse color "${color}"`);
    }
    while (color.l > 0 && getContrast(colord(color).toHex()) < contrast) {
        color.l -= 1;
    }
    if (l - color.l < minimumLightnessDistance) {
        color.l = l - minimumLightnessDistance;
    }
    return colord(color).toHex();
}
function getContrast(color) {
    const contrastColor = '#fffdf9';
    return tinycolor.readability(color, contrastColor);
}
//# sourceMappingURL=darkenColor.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
